import { createBusinessClient } from '@beatq/sdk';
import { csrfHeaders, getAccessToken } from '@beatq/shared';
import { getApiBaseUrl } from './config.js';
export function getBusinessClient() {
    return createBusinessClient({
        baseUrl: getApiBaseUrl(),
        credentials: 'include',
        accessToken: getAccessToken() ?? undefined,
        headers: csrfHeaders(),
    });
}
//# sourceMappingURL=business.js.map